import "./styles.scss";

const Loading = () => (
  <div className="contract-details-sidebar__loading">
    <div className="spinnerInfoBox display-flex justify-content-center align-items-center">
      <div className="spinner" />
      <div className="spinnerText">Carregando detalhes do contrato...</div>
    </div>
  </div>
);

export default Loading;
